import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Label,
  ListGroup,
  ListGroupItem,
  FormGroup,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { MyModal } from "../../../src/MyForders/Components";
import DateTimeHelper from "../../../src/assets/utils/helpers/DateTimeHelper";
import dayjs from "dayjs";
import { onFetchListSid } from "../../Api/AppBackend/ListSid";
import { DatePicker, Input, message } from "antd";

import SidService from "../../../src/Views/Sid/SidService";
import "./Sid.css";
import ResultModalV2 from "./ResultModalV2";
import ApiCaller from "../../lib/ApiCaller";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as configApi from "../../config/configApi.js";
import Loader from "react-loaders";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Checking(props) {
  //Load thư viện PDF
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  //---------------------------------------------------
  const [listData, setListData] = useState([]);
  // const [filter, setFilter] = useState({ pid: ""});
  const [isShowModal, setIsShowModal] = useState(false);
  const [width, setWidth] = useState(0);
  const [pdfData, setPdfData] = useState(null);
  const [itemView, setItemView] = useState();
  const [scale, setScale] = useState(1);
  const [fromDate, setFromDate] = useState(dayjs().startOf("day"));
  const [toDate, setToDate] = useState(dayjs().endOf("day"));
  const [typeUser, setTypeUser] = useState(null);

  const [filterSearch, setFilterSearch] = useState("");
  //pdf page
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [showModelResult, setShowModalResult] = useState(false);
  const [listPage, setListPage] = useState(null);
  const [adminData, setAdminData] = useState([]);
  const { RangePicker } = DatePicker;
  const [showInput, setShowInput] = useState(false);
  const dateFormatList = [
    "DD/MM/YYYY",
    "DD/MM/YY",
    "DD-MM-YYYY",
    "DD-MM-YY",
  ];
  const [loading, setLoading] = useState(false);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }
  const primaryColor = configApi.USE_COLOR;

  useEffect(() => {
    const userType = localStorage.getItem("typeUser");
    if (userType) {
      setTypeUser(userType);
    }
  }, []);
  
  useEffect(() => {
    if (typeUser === "1" || typeUser === "2" || typeUser === "3") {
      getListSid();
    } else if (typeUser === "4") {
      getList();
    }
    if (window.innerWidth > 450) {
      setScale(1);
    } else {
      setScale(6);
    }

    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [typeUser, fromDate, toDate]);

  useEffect(() => {
    getList();
  }, [props.dateIn]);

  // useEffect(() => {
  //   getListSid();
  // }, [fromDate, toDate]);

  useEffect(() => {
    setShowInput(ckTypeUser());
  }, []);

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [newFromDate, newToDate] = dates;
      if (newFromDate.isBefore(newToDate) || newFromDate.isSame(newToDate)) {
        setFromDate(newFromDate);
        setToDate(newToDate);
      } else {
        setFromDate(newFromDate);
        setToDate(newToDate);
      }
    }
  };

  const getListSid = async () => {
    if (fromDate && toDate) {
      try {
        setLoading(true)
        const formattedFromDate = fromDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const formattedToDate = toDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const data = {
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          filterSearch,
        };
        const res = await onFetchListSid(data);
        if (res.data.isSuccess && Array.isArray(res.data.data)) {
          setAdminData(res.data.data);
          message.success(props.t("Data Refreshed Successfully"));
        }
      } catch (error) {}
      finally{
        setLoading(false)
      }
    }
  };

  const handleSearchChange = (e) => {
    if (e.key === "Enter") {
      getListSid(filterSearch);
    }
  };

  const getList = () => {
    const filter = {
      pid: props.pid,
      dateIn: props.dateIn,
    };
    if (!filter.pid) {
      return;
    }
    SidService.GetListSid(filter).then((res) => {
      if (res.data.isSuccess) {
        setListData(res.data.data);
      }
    });
  };
  function onDocumentLoadSuccess({ numPages }) {
    var _numPages = [];
    for (var i = 0; i < numPages; i++) {
      _numPages.push(i + 1);
    }
    setListPage(_numPages);
    setNumPages(numPages);
  }
  //Tải file pdf
  const DownloadListSignaturePdf = (item) => {
    const URI =
      "/Signature/DownloadListSignaturePdf?Sitecode=" +
      item.siteCode +
      "&SID=" +
      item.sid +
      "&ID=" +
      item.rowguid;
    window.location.href = configApi.URL_API + URI;
  };
  //Xem file PDF
  const ViewResultPDF = (data) => {
    setPdfData("");
    SidService.GetFileResultBase64Info(data.sid, data.siteCode).then((res) => {
      if (res.data.isSuccess) {
        const blob = base64toBlob(
          "data:application/pdf;base64," + res.data.item.pdfBase64
        );
        const url = URL.createObjectURL(blob);
        setPdfData(url);
        toggle();
      }
    });
  };
  const toggle = () => {
    setIsShowModal(!isShowModal);
  };
  const base64toBlob = (data) => {
    const base64WithoutPrefix = data.substr(
      "data:application/pdf;base64,".length
    );
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: "application/pdf" });
  };

  const ckTypeUser = () => {
    const typeUser = localStorage.getItem("typeUser");
    return typeUser === "1" || typeUser === "2" || typeUser === "3";
  };
  // const GetResult = (sid, sitecode) => {
  //   ApiCaller.get(
  //     `/PatientCenter/GetPatientInfo?sid=${sid}&sitecode=${sitecode}`
  //   ).then((res) => {
  //     if (res.data.isSuccess) {
  //       let item = res.data.data[0];
  //       console.log("PATIENT", item);
  //       let data = [];
  //       let stt = 0;
  //       for (let rec of item.listTestResult) {
  //         if (rec.listSubTestResult && rec.listSubTestResult.length > 0) {
  //           stt += 1;
  //           rec.stt = stt;
  //           rec.isParrent = true;
  //           rec.PatientName = item.patientName;
  //           rec.DateOfBirth = item.dateOfBirth;
  //           rec.Sex = item.sex == "M" ? "Nam" : item.sex == "F" ? "Nữ" : "?";
  //           rec.Address = item.address;
  //           rec.Description = item.description;
  //           data.push(rec);
  //           // data = data.concat(rec.listSubTestResult);
  //         } else {
  //           stt += 1;
  //           rec.stt = stt;
  //           rec.isParrent = true;
  //           rec.PatientName = item.patientName;
  //           rec.DateOfBirth = item.dateOfBirth;
  //           rec.Sex = item.sex == "M" ? "Nam" : item.sex == "F" ? "Nữ" : "?";
  //           rec.Address = item.address;
  //           rec.Description = item.description;
  //           data.push(rec);
  //         }
  //       }
  //       console.log("Select data:", data);
  //       setDataTest(data);
  //     }
  //   });
  // };

  const refA = useRef(null);
  return (
    <div>
      <div
        className="input-container"
        // style={{
        //   display: "flex",
        //   alignItems: "center",
        //   gap: "10px",
        //   paddingBottom: "5px",
        //   paddingLeft: "15px",
        //   // paddingTop: "25px"
        // }}
      >
        {showInput && (
          <>
            <div
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                color: "black",
              }}
            >
              {props.t('Date of Receipt:  ')}
            </div>
            <RangePicker
              format={dateFormatList}
              size="large"
              showTime={false}
              allowClear={false}
              defaultValue={[dayjs(fromDate), dayjs(toDate)]}
              onChange={handleDateChange}
              style={{ borderColor: "#d9d9d9" }}
            />
            <div
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                color: "black",
              }}
            >
              {props.t('Search for Patient:  ')}
            </div>
            <Input
              style={{
                fontSize: "15px",
                fontWeight: 600,
                height: "40px",
                minWidth: "230px",
                width: "auto",
                borderColor: "#d9d9d9",
              }}
              placeholder={props.t('Enter the SID, PID, FullName')}
              onChange={(e) => setFilterSearch(e.target.value)}
              onKeyPress={handleSearchChange}
            />
            <Button 
              type="primary" color="primary" 
              style={{ padding: 5, backgroundColor: primaryColor }}
              onClick={()=>{
                getListSid(filterSearch);
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.27586 16C5.96552 16 4.00862 15.225 2.40517 13.675C0.801724 12.125 0 10.2333 0 8C0 5.76667 0.801724 3.875 2.40517 2.325C4.00862 0.775 5.96552 0 8.27586 0C9.46552 0 10.6034 0.237333 11.6897 0.712C12.7759 1.18667 13.7069 1.866 14.4828 2.75V0H16.5517V7H9.31034V5H13.6552C13.1034 4.06667 12.349 3.33333 11.3917 2.8C10.4345 2.26667 9.39586 2 8.27586 2C6.55172 2 5.08621 2.58333 3.87931 3.75C2.67241 4.91667 2.06897 6.33333 2.06897 8C2.06897 9.66667 2.67241 11.0833 3.87931 12.25C5.08621 13.4167 6.55172 14 8.27586 14C9.60345 14 10.8017 13.6333 11.8707 12.9C12.9397 12.1667 13.6897 11.2 14.1207 10H16.2931C15.8103 11.7667 14.8276 13.2083 13.3448 14.325C11.8621 15.4417 10.1724 16 8.27586 16Z"
                  fill="white"
                />
              </svg>
            </Button>
          </>
        )}
      </div>
      <div
        style={{
            height: "calc(100vh - 200px)",
            maxHeight: "770px",
            overflowY: "auto",
        }}
      >
        <React.Fragment>
          <CSSTransitionGroup
            component="div"
            transitionName="TabsAnimation"
            transitionAppear={true}
            transitionAppearTimeout={0}
            transitionEnter={false}
            transitionLeave={false}
          >
            <Row style={{ marginRight: 0, marginLeft: 0, overflowY: "auto", paddingBottom: "50px"}}>
              <Col sm="12" style={{ padding: 0 }}>
                <ListGroup className="todo-list-wrapper" flush>
                  {listData.map((itemsign) => {
                    return (
                      <ListGroupItem>
                        <div
                          className="todo-indicator"
                          style={{ backgroundColor: primaryColor, opacity: 1}}
                        />
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <Row className="w-100">
                              <Col sm={12} md={12} lg={8}>
                                <div
                                  className="widget-content-left d-flex align-items-center"
                                  style={{ height: "100%" }}
                                >
                                  <div
                                    className="widget-heading"
                                    style={{ opacity: 1, color: primaryColor }}
                                  >
                                    <span style={{ color: "black" }}>SID:</span>{" "}
                                    <b>{itemsign.sid}</b>{" "}
                                    <span style={{ color: "black" }}>PID:</span>{" "}
                                    <b>{itemsign.pid}</b>
                                    <span
                                      style={{ color: "black", paddingLeft: 9 }}
                                    >
                                     {props.t('FULLNAME')}
                                    </span>{" "}
                                    <b>{itemsign.patientName}</b>
                                    <span
                                      style={{ color: "black", paddingLeft: 9 }}
                                    >
                                      {props.t('DATE OF MEDICAL EXAMINATION')}
                                    </span>{" "}
                                    <b>
                                      {DateTimeHelper.getDateString(
                                        itemsign.dateIn
                                      )}
                                    </b>
                                  </div>
                                </div>
                              </Col>

                              <Col sm={12} md={12} lg={4}>
                              {itemsign.isResult ? (
                                <div
                                  className={`w-100 d-flex ${
                                    width > 991 || !width
                                      ? "justify-content-end"
                                      : "justify-content-start mt-3"
                                  }`}
                                >
                                  {configApi.ENABLE_VIEW_SIGNED_FILE &&(
                                  <button
                                    className="mb-1 mr-2 btn-shadow btn"
                                    style={{
                                      backgroundColor: primaryColor,
                                      color: "#FFF",
                                    }}
                                    onClick={() => ViewResultPDF(itemsign)}
                                  >
                                    <div className="d-flex align-items-center">
                                      <FontAwesomeIcon icon={faFilePdf} />
                                      <div className="ml-1">{props.t('VIEW SIGNED FILE')}</div>
                                    </div>
                                  </button>
                                  )}
                                  {configApi.ENABLE_VIEW_SIGNED_FILE &&(
                                  <button
                                    className="mb-1 mr-2 btn-shadow btn"
                                    style={{
                                      backgroundColor: primaryColor,
                                      color: "#FFF",
                                    }}
                                    onClick={() =>
                                      DownloadListSignaturePdf(itemsign)
                                    }
                                  >
                                    <div className="d-flex align-items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1.3em"
                                        height="1.3em"
                                        viewBox="0 0 24 24"
                                      >
                                        <g
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                        >
                                          <path
                                            fill="none"
                                            stroke-dasharray="14"
                                            stroke-dashoffset="14"
                                            d="M6 19h12"
                                          >
                                            <animate
                                              fill="freeze"
                                              attributeName="stroke-dashoffset"
                                              dur="0.4s"
                                              values="14;0"
                                            />
                                          </path>
                                          <path
                                            fill="currentColor"
                                            d="M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5"
                                          >
                                            <animate
                                              attributeName="d"
                                              calcMode="linear"
                                              dur="1.5s"
                                              keyTimes="0;0.7;1"
                                              repeatCount="indefinite"
                                              values="M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5;M12 4 h2 v3 h2.5 L12 11.5M12 4 h-2 v3 h-2.5 L12 11.5;M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5"
                                            />
                                          </path>
                                        </g>
                                      </svg>
                                      <div className="ml-1">
                                      {props.t('DOWNLOAD RESULT FILE')}
                                      </div>
                                    </div>
                                  </button>
                                  )}
                                  
                                </div>
                              ):(
                                <div
                                  className={`w-100 d-flex ${
                                    width > 991 || !width
                                      ? "justify-content-end"
                                      : "justify-content-start mt-3"
                                  }`}
                                >
                                  <button
                                      className="mb-1 mr-2 btn-shadow btn"
                                      style={{
                                        backgroundColor: "#f7b924",
                                        color: "black",
                                      }}
                                    >
                                    <div className="d-flex align-items-center">
                                      <div className="ml-1">{props.t('NO RESULTS')}</div>
                                    </div>
                                  </button>
                                </div>
                              )}
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </ListGroupItem>
                    );
                  })}
                </ListGroup>
                <ListGroup className="todo-list-wrapper" flush>
                  {
                    loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: "200px", width: "100%" }}
                      >
                        <Loader type="ball-pulse-rise" color="#007bff" />
                      </div>
                    ):(
                      adminData.map((itemsign) => {
                        return (
                          <ListGroupItem>
                            <div
                              className="todo-indicator"
                              style={{ backgroundColor: primaryColor, opacity: 1 }}
                            />
                            <div className="widget-content p-0">
                              <div className="widget-content-wrapper">
                                <Row className="w-100">
                                  <Col sm={12} md={12} lg={8}>
                                    <div
                                      className="widget-content-left d-flex align-items-center"
                                      style={{ height: "100%" }}
                                    >
                                      <div
                                        className="widget-heading"
                                        style={{ opacity: 1, color: primaryColor }}
                                      >
                                        <span style={{ color: "black" }}>SID:</span>{" "}
                                        <b>{itemsign.sid}</b>{" "}
                                        <span style={{ color: "black" }}>PID:</span>{" "}
                                        <b>{itemsign.pid}</b>
                                        <span
                                          style={{ color: "black", paddingLeft: 9 }}
                                        >
                                          {props.t('FULLNAME')}
                                        </span>{" "}
                                        <b>{itemsign.patientName}</b>
                                        <span
                                          style={{ color: "black", paddingLeft: 9 }}
                                        >
                                          {props.t('DATE OF MEDICAL EXAMINATION')}
                                        </span>{" "}
                                        <b>
                                          {DateTimeHelper.getDateString(
                                            itemsign.dateIn
                                          )}
                                        </b>
                                      </div>
                                    </div>
                                  </Col>
    
                                  <Col sm={12} md={12} lg={4}>
                                  {itemsign.isResult ? (
                                    <div
                                      className={`w-100 d-flex ${
                                        width > 991 || !width
                                          ? "justify-content-end"
                                          : "justify-content-start mt-3"
                                      }`}
                                    >
                                      {configApi.ENABLE_VIEW_SIGNED_FILE &&(
                                      <button
                                        className="mb-1 mr-2 btn-shadow btn"
                                        style={{
                                          backgroundColor: primaryColor,
                                          color: "#FFF",
                                        }}
                                        onClick={() => {
                                          ViewResultPDF(itemsign)
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <FontAwesomeIcon icon={faFilePdf} />
                                          <div className="ml-1">{props.t('VIEW SIGNED FILE')}</div>
                                        </div>
                                      </button>
                                      )}
                                      {configApi.ENABLE_VIEW_SIGNED_FILE &&(
                                      <button
                                        className="mb-1 mr-2 btn-shadow btn"
                                        style={{
                                          backgroundColor: primaryColor,
                                          color: "#FFF",
                                        }}
                                        onClick={() =>
                                          DownloadListSignaturePdf(itemsign)
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1.3em"
                                            height="1.3em"
                                            viewBox="0 0 24 24"
                                          >
                                            <g
                                              stroke="currentColor"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="2"
                                            >
                                              <path
                                                fill="none"
                                                stroke-dasharray="14"
                                                stroke-dashoffset="14"
                                                d="M6 19h12"
                                              >
                                                <animate
                                                  fill="freeze"
                                                  attributeName="stroke-dashoffset"
                                                  dur="0.4s"
                                                  values="14;0"
                                                />
                                              </path>
                                              <path
                                                fill="currentColor"
                                                d="M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5"
                                              >
                                                <animate
                                                  attributeName="d"
                                                  calcMode="linear"
                                                  dur="1.5s"
                                                  keyTimes="0;0.7;1"
                                                  repeatCount="indefinite"
                                                  values="M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5;M12 4 h2 v3 h2.5 L12 11.5M12 4 h-2 v3 h-2.5 L12 11.5;M12 4 h2 v6 h2.5 L12 14.5M12 4 h-2 v6 h-2.5 L12 14.5"
                                                />
                                              </path>
                                            </g>
                                          </svg>
                                          <div className="ml-1">
                                          {props.t('DOWNLOAD RESULT FILE')}
                                          </div>
                                        </div>
                                      </button>
                                      )}
                                      
                                    </div>
                                  ):(
                                    <div
                                      className={`w-100 d-flex ${
                                        width > 991 || !width
                                          ? "justify-content-end"
                                          : "justify-content-start mt-3"
                                      }`}
                                      >
                                      <button
                                        className="mb-1 mr-2 btn-shadow btn"
                                        style={{
                                          backgroundColor: "#f7b924",
                                          color: "black",
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <div className="ml-1">{props.t('NO RESULTS')}</div>
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </ListGroupItem>
                        );
                      })
                    )
                  }
                </ListGroup>
                <ResultModalV2
                  isOpen={showModelResult}
                  setIsOpen={setShowModalResult}
                  itemView={itemView}
                />
              </Col>
            </Row>
            <MyModal
              style={{ width: "100%" }}
              className="modal-fullscreen"
              isOpen={isShowModal}
              unmountOnClose={true}
              toggle={toggle}
            >
              <ModalHeader
                toggle={toggle}
                className="center"
                style={{ background: configApi.USE_COLOR, color: "#fff" }}
              >
                <h5 style={{ width: "100%", textAlign: "center" }}>
                  KẾT QUẢ XÉT NGHIỆM
                </h5>
              </ModalHeader>
              <ModalBody style={{ overflowY: "auto" }}>
                <div>
                  <Document
                    file={pdfData}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {listPage != undefined && listPage.length > 0 ? (
                      listPage.map((pageNumber) => (
                        <Page
                          pageNumber={pageNumber}
                          scale={window.innerWidth < 768 ? 0.7 : 1.5}
                          printOut={true}
                        />
                      ))
                    ) : (
                      <div></div>
                    )}
                  </Document>
                </div>
              </ModalBody>
            </MyModal>
          </CSSTransitionGroup>
        </React.Fragment>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
 withTranslation(["dashboard"]) (Checking));
